<template>
  <div
    class="video-media-list-item"
    :class="{ 'video-media-list-item_active': isActive }"
  >
    <ListItemImage
      :background-url="parsedVideo?.thumbnail"
      :is-active="isActive"
      :overlay="!isActive"
    >
      <template #overlay>
        <IconTriangle class="video-media-list-item__play-icon" />
      </template>
    </ListItemImage>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { StrapiVideoMedia } from '@/services/product/types';
import ListItemImage from './inner/ListItemImage.vue';
import IconTriangle from '../icons/IconTriangle.vue';

const props = defineProps<{
  media: StrapiVideoMedia;
  isActive: boolean;
}>();

const parsedVideo = computed(() => {
  if (props.media.video) {
    const parsedFromJson = JSON.parse(props.media.video);

    const { html } = parsedFromJson.rawData;

    const src = html.match(/src="([^"]+)"/)?.[1];

    return {
      ...parsedFromJson,
      src
    };
  }

  return null;
});
</script>

<style scoped>
.video-media-list-item {
  width: 100%;
  height: 100%;
  position: relative;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &_active {
    .video-media-list-item__overlay {
      display: none;
    }
  }

  &__play-icon {
    color: #fff;
    transform: rotate(-90deg);
  }
}
</style>
